// Small in-house UI kit: only the pieces that need JavaScript.
// Everything else (buttons, cards, tags, grid…) is plain HTML + classes
// from src/styles/components.css and src/styles/layout.css.

export { default as Modal } from './Modal';
export { default as Drawer } from './Drawer';
export { default as Dropdown } from './Dropdown';
export { default as Popconfirm } from './Popconfirm';
export { default as Tabs } from './Tabs';
export { default as Steps } from './Steps';
export { default as Table } from './Table';
export { default as Pagination } from './Pagination';
export { default as Carousel } from './Carousel';
export { default as Rating } from './Rating';
export { default as Image, ImagePreviewGroup, Lightbox } from './Image';
export { default as TagsInput } from './TagsInput';
export { default as QRCode } from './QRCode';
export { toast, Toaster } from './toast';
export { Form, Field, useForm, useFormInstance } from './form';
export { cx } from './hooks';

/** Number with thousands separators: 12345.6 -> "12,345.6". */
export function formatNumber(value, precision) {
  const num = Number(value);
  if (value === null || value === undefined || value === '' || Number.isNaN(num)) return value ?? '';
  const options =
    precision === undefined ? {} : { minimumFractionDigits: precision, maximumFractionDigits: precision };
  return num.toLocaleString('en-US', options);
}
